<!-- =====================================================================
     LAUDITOR PRODUCT — REVAMPED REGISTER DESIGN
     ===================================================================== -->
<ng-container *ngIf="product === 'lauditor'">
  <div class="lx-page-container">

    <!-- LEFT HERO PANEL -->
    <div class="lx-left-section">
      <div class="lx-blob lx-blob-1"></div>
      <div class="lx-blob lx-blob-2"></div>
      <div class="lx-bg-dots" aria-hidden="true"></div>

      <div class="lx-hero-content">
        <div class="lx-hero-top">
          <h1 class="lx-hero-title">Your entire legal practice, organized on one secure platform</h1>
          <!-- <div class="lx-hero-divider" aria-hidden="true"></div> -->
          <!-- <p class="lx-hero-subtitle">Manage matters, clients, documents, billing, appointments and more—all in one secure place.</p> -->
        </div>

        <div class="lx-illustration-wrap">
          <!-- <span class="lx-float-icon lx-float-shield" aria-hidden="true"><i class="fa fa-shield"></i></span>
          <span class="lx-float-icon lx-float-doc" aria-hidden="true"><i class="fa fa-file-text"></i></span>
          <span class="lx-float-icon lx-float-cloud" aria-hidden="true"><i class="fa fa-cloud"></i></span> -->
          <img src="/assets/site/images/illustration_bg.png" alt="Lex-Z Digital" class="lx-illustration">
        </div>

        <!-- <div class="lx-feature-row">
          <div class="lx-feature-item">
            <i class="fa fa-shield" aria-hidden="true"></i>
            <span>Bank-grade Security</span>
          </div>
          <div class="lx-feature-item">
            <i class="fa fa-cloud" aria-hidden="true"></i>
            <span>Access Anywhere</span>
          </div>
          <div class="lx-feature-item">
            <i class="fa fa-balance-scale" aria-hidden="true"></i>
            <span>Built for Law Firms</span>
          </div>
        </div> -->
      </div>

      <div class="lx-copyright">Lex-Z Lawyers 2026. All rights reserved.</div>
    </div>

    <!-- RIGHT FORM PANEL -->
    <div class="lx-right-section">
      <div class="lx-form-container">

        <!-- Logo -->
        <div class="lx-login-header">
          <img src="/assets/img/lexi-zlogo2.png" alt="Lex-Z" class="lx-logo">
        </div>

        <!-- Alert message -->
        <label class="lx-alert-msg" *ngIf="msg" [style.color]="msgError ? '#dc2626' : '#16a34a'">
          {{msg}}
        </label>

        <h2 class="lx-form-title">
          {{ otpSent ? 'Verify OTP' : 'Create your account' }}
        </h2>
        <p class="lx-form-subtitle" *ngIf="!otpSent">
          Fill in the details to sign up and grow your business.
        </p>

        <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">

          <!-- Name field (hidden after OTP sent) -->
          <div class="lx-field-wrap" *ngIf="!otpSent">
            <input
              formControlName="fullname"
              class="lx-input"
              id="id_fullname"
              type="text"
              (keypress)="onlyLetters($event)"
              placeholder="Full Name" />
            <div *ngIf="otpSubmitted && otpF['fullname'].errors" class="lx-error">
              <span *ngIf="otpF.fullname.errors.required">Name is required</span>
            </div>
          </div>

          <!-- Email field (hidden after OTP sent) -->
          <div class="lx-field-wrap" *ngIf="!otpSent">
            <input
              formControlName="email"
              class="lx-input"
              id="id_email"
              type="email"
              placeholder="Email Address"
              autocomplete="email" />
            <div *ngIf="otpSubmitted && otpF['email'].errors" class="lx-error">
              <span *ngIf="otpF.email.errors.required">Email is required</span>
              <span *ngIf="otpF.email.errors.invalidEmail">Please enter a valid email address</span>
            </div>
          </div>

          <!-- Mobile Number field (hidden after OTP sent) -->
          <div class="lx-field-wrap" *ngIf="!otpSent">
            <input
              formControlName="phone"
              class="lx-input"
              id="id_phone"
              type="tel"
              inputmode="numeric"
              maxlength="10"
              placeholder="Mobile Number"
              autocomplete="tel"
              (input)="onPhoneInput($event)" />
            <div *ngIf="otpSubmitted && otpF['phone'].errors" class="lx-error">
              <span *ngIf="otpF.phone.errors.required">Mobile number is required</span>
              <span *ngIf="otpF.phone.errors.invalidPhone">Please enter a valid phone number</span>
            </div>
          </div>

          <!-- OTP sent message -->
          <!-- <div *ngIf="otpSent" class="lx-otp-sent-msg">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#1d4ed8"/><path d="M4.5 8l2.5 2.5 4-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            OTP sent successfully
          </div> -->

          <!-- OTP boxes (shown after OTP sent) -->
          <div class="lx-otp-section" *ngIf="otpSent">
            <label class="lx-otp-label">Enter 6-digit OTP</label>
            <div class="lx-otp-boxes">
              <input #otp1 type="text" maxlength="1" inputmode="numeric"
                class="lx-otp-box"
                (keyup)="onOtpKeyUp($event, 1, otp2)"
                (paste)="onOtpPaste($event)"
                [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"/>
              <input #otp2 type="text" maxlength="1" inputmode="numeric"
                class="lx-otp-box"
                (keyup)="onOtpKeyUp($event, 2, otp3)"
                [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"/>
              <input #otp3 type="text" maxlength="1" inputmode="numeric"
                class="lx-otp-box"
                (keyup)="onOtpKeyUp($event, 3, otp4)"
                [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"/>
              <input #otp4 type="text" maxlength="1" inputmode="numeric"
                class="lx-otp-box"
                (keyup)="onOtpKeyUp($event, 4, otp5)"
                [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"/>
              <input #otp5 type="text" maxlength="1" inputmode="numeric"
                class="lx-otp-box"
                (keyup)="onOtpKeyUp($event, 5, otp6)"
                [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"/>
              <input #otp6 type="text" maxlength="1" inputmode="numeric"
                class="lx-otp-box"
                (keyup)="onOtpKeyUp($event, 6, null)"
                [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"/>
            </div>

            <div *ngIf="otpSubmitted && otpF['otp'].errors" class="lx-error">
              <span *ngIf="otpF['otp'].errors.required">OTP is required</span>
              <span *ngIf="otpF['otp'].errors.pattern">OTP must be 6 digits</span>
            </div>

            <!-- Resend -->
            <div class="lx-resend-row">
              <a href="javascript:void(0);"
                class="lx-resend-link"
                [class.lx-resend-disabled]="resendDisabled"
                (click)="resendOTP()">
                {{ resendDisabled ? 'Resend OTP in ' + resendTimer + 's' : 'Resend OTP' }}
              </a>
            </div>
          </div>

          <!-- Buttons -->
          <div class="lx-btn-row">
            <button type="button"
              class="lx-btn lx-btn-cancel"
              *ngIf="otpSent"
              (click)="cancelRegistration()">Cancel</button>
            <button type="submit"
              class="lx-btn lx-btn-primary"
              [disabled]="otpRequestInProgress">
              <span *ngIf="otpRequestInProgress" class="lx-spinner"></span>
              {{ otpSent ? 'Verify OTP' : 'Send OTP' }}
            </button>
          </div>


          <!-- Login link -->
          <div class="lx-register-prompt" *ngIf="!otpSent">
            Already have an account?
            <a routerLink="/login" class="lx-register-link">Log In</a>
          </div>
        </form>

        <!-- Mobile-only footer (hidden on tablet/desktop via CSS) -->
        <div class="lx-mobile-footer">Lex-Z Lawyers &copy; 2026. All rights reserved.</div>
      </div>
    </div>
  </div>

  <!-- ── Confirmation Dialog (lauditor) ─────────────────────────────── -->
  <div class="lx-confirm-overlay" *ngIf="showConfirmDialog" (click)="$event.stopPropagation()">
    <div class="lx-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="lx-confirm-title">
      <h3 class="lx-confirm-title" id="lx-confirm-title">Confirm Details</h3>
      <p class="lx-confirm-body">
        Please confirm your email address <strong>{{confirmDisplayEmail}}</strong> and phone number <strong>{{confirmDisplayPhone}}</strong>.
      </p>
      <div class="lx-confirm-actions">
        <button type="button" class="lx-btn lx-btn-secondary" (click)="cancelConfirm()">No, Edit</button>
        <button type="button" class="lx-btn lx-btn-primary" (click)="confirmAndProceed()">Yes, Continue</button>
      </div>
    </div>
  </div>

</ng-container>
<ng-container *ngIf="product !== 'lauditor'">
  <div class="">
    <div class="row">
      <div class="col-sm-7 loginbglauditor" *ngIf="product === 'corporate' || product == 'indiamp'"></div>
      <div class="col-sm-7 loginbgcontent" *ngIf="product == 'content'"></div>
      <div class="col-sm-7 loginbgconnect" *ngIf="product == 'connect'"></div>
      <div class="col-sm-5">
        <div class="row">

          <div class="col-sm-12">
            <div class="logomain" *ngIf="product === 'indiamp'">
              <img src="/assets/img/WEBLEXIZLawyerTP.png" class="loginlogolexiz">
            </div>

            <div class="logomain" *ngIf="product === 'corporate'">
              <img src="/assets/img/WEBLEXIZCorporateTP.png" class="loginlogolexiz">
            </div>

            <div class="logomain" *ngIf="product == 'content'">
              <img src="/assets/site/images/content_logo.jpg" class="loginlogocontent">
            </div>

            <div class="logomainconnect" *ngIf="product == 'connect'">
              <img src="/assets/site/images/cofferconnect-logo.png" class="loginlogoconnect">
              <div class="logotxtconnect">Coffer Connect</div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="loginform">
              <label id="id_alert" class="logininfo"
                    [style.color]="msgError ? 'red' : 'green'">
                {{msg}}
              </label>

              <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
                <div class="signin">Register With OTP</div>

                <div class="form-floating mb-3 mt-3" *ngIf="!otpSent">
                  <input
                    formControlName="fullname"
                    class="form-control custominput"
                    id="id_fullname"
                    type="text" (keypress)="onlyLetters($event)"
                    placeholder="Name" />
                  <label for="id_fullname" class="lblfocus">Name</label>
                  <div *ngIf="otpSubmitted && otpF['fullname'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF.fullname.errors.required">Name is required</div>
                  </div>
                </div>

                <div class="form-floating mb-3 mt-3" *ngIf="!otpSent">
                  <input
                    formControlName="email"
                    class="form-control custominput"
                    id="id_email"
                    type="email"
                    placeholder="Email Address"
                    autocomplete="email" />
                  <label for="id_email" class="lblfocus">Email Address</label>
                  <div *ngIf="otpSubmitted && otpF['email'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF.email.errors.required">Email is required</div>
                    <div class="errorStyle" *ngIf="otpF.email.errors.invalidEmail">Please enter a valid email address</div>
                  </div>
                </div>

                <div class="form-floating mb-3 mt-3" *ngIf="!otpSent">
                  <input
                    formControlName="phone"
                    class="form-control custominput"
                    id="id_phone"
                    type="tel"
                    inputmode="numeric"
                    maxlength="10"
                    placeholder="Mobile Number"
                    autocomplete="tel"
                    (input)="onPhoneInput($event)" />
                  <label for="id_phone" class="lblfocus">Mobile Number</label>
                  <div *ngIf="otpSubmitted && otpF['phone'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF.phone.errors.required">Mobile number is required</div>
                    <div class="errorStyle" *ngIf="otpF.phone.errors.invalidPhone">Please enter a valid phone number</div>
                  </div>
                </div>

                <div class="otp-input-section" *ngIf="otpSent">
                  <label class="otp-label">Enter OTP</label>
                  <div class="otp-inputs-container">
                    <input #otp1 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 1, otp2)" (paste)="onOtpPaste($event)"
                      [(ngModel)]="otpDigits[0]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp2 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 2, otp3)"
                      [(ngModel)]="otpDigits[1]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp3 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 3, otp4)"
                      [(ngModel)]="otpDigits[2]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp4 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 4, otp5)"
                      [(ngModel)]="otpDigits[3]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp5 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 5, otp6)"
                      [(ngModel)]="otpDigits[4]" [ngModelOptions]="{standalone: true}"/>
                    <input #otp6 type="text" maxlength="1" class="otp-box custominput"
                      (keyup)="onOtpKeyUp($event, 6, null)"
                      [(ngModel)]="otpDigits[5]" [ngModelOptions]="{standalone: true}"/>
                  </div>
                  <div *ngIf="otpSubmitted && otpF['otp'].errors" class="text-danger">
                    <div class="errorStyle" *ngIf="otpF['otp'].errors.required">OTP is required</div>
                    <div class="errorStyle" *ngIf="otpF['otp'].errors.pattern">OTP must be 6 digits</div>
                  </div>
                  <div class="resend-otp" *ngIf="otpSent">
                    <a href="javascript:void(0);" class="resend-link"
                      [class.disabled]="resendDisabled"
                      (click)="resendOTP()">
                      {{ resendDisabled ? 'Resend OTP in ' + resendTimer + 's' : 'Resend OTP' }}
                    </a>
                  </div>
                </div>

                <div class="btnlogin">
                  <button type="button" class="btn btnlogincancel btncomman"
                    *ngIf="otpSent" (click)="cancelRegistration()">Cancel</button>
                  <button type="submit" class="btn btn-primary btnloginsubmit btncomman"
                    [disabled]="otpRequestInProgress">
                    {{ otpSent ? 'Verify OTP' : 'Send OTP' }}
                  </button>
                </div>

                <div class="text-center mt-3" style="margin-top: 15px;">
                  <span style="color: #000000; font-size: 14px;">
                    Already have an account?
                    <a routerLink="/login" style="color: #004D87; font-weight: 600; text-decoration: underline; cursor: pointer;">Log In</a>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Confirmation Dialog (non-lauditor) ─────────────────────────── -->
  <div class="lx-confirm-overlay" *ngIf="showConfirmDialog" (click)="$event.stopPropagation()">
    <div class="lx-confirm-modal" role="dialog" aria-modal="true" aria-labelledby="lx-confirm-title-2">
      <h3 class="lx-confirm-title" id="lx-confirm-title-2">Confirm Details</h3>
      <p class="lx-confirm-body">
        Please confirm your email address <strong class="highlightone">{{confirmDisplayEmail}}</strong> and phone number <strong class="highlightone">{{confirmDisplayPhone}}</strong>.
      </p>
      <div class="lx-confirm-actions">
        <button type="button" class="btn btnlogincancel btncomman" (click)="cancelConfirm()">No, Edit</button>
        <button type="button" class="btn btn-primary btnloginsubmit btncomman" (click)="confirmAndProceed()">Yes, Continue</button>
      </div>
    </div>
  </div>

</ng-container>